import classNames from "classnames";
import { JSX } from "react";
import styles from "./Input.module.css";

type Props = JSX.IntrinsicElements["input"] & {
  isInvalid?: boolean;
};

const Input = ({
  isInvalid,
  className,
  type = "text",
  autoComplete = "off",
  spellCheck = "false",
  ...props
}: Props) => (
  <input
    {...props}
    type={type}
    autoComplete={autoComplete}
    spellCheck={spellCheck}
    className={classNames(styles.input, className, {
      [styles.invalid]: isInvalid,
    })}
  />
);

export default Input;
